import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=1dda2f2e&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=1dda2f2e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dda2f2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dda2f2e')) {
      api.createRecord('1dda2f2e', component.options)
    } else {
      api.reload('1dda2f2e', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=1dda2f2e&scoped=true&", function () {
      api.rerender('1dda2f2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZETQSZRphW4Y/JS/comp/Paginate.vue"
export default component.exports